import { useMemo } from 'react';
import { useForm } from 'react-final-form';
import { TravellerFields } from '../../types';
import { useTranslation } from 'react-i18next';
export const useDirections = (cities) => {
    var _a;
    const { t } = useTranslation('Traveller');
    const form = useForm();
    const { departure, arrival } = (_a = form.getState()) === null || _a === void 0 ? void 0 : _a.values;
    const options = useMemo(() => {
        return (cities === null || cities === void 0 ? void 0 : cities.map(city => ({ label: city.name, value: city.iata }))) || [];
    }, [cities]);
    const fields = useMemo(() => [
        {
            queryFieldName: TravellerFields.DepartureQuery,
            arrayFieldName: TravellerFields.Departure,
            selectedOptions: departure,
            label: t('Departure cities'),
            icon: 'Flight/Takeoff',
            selectedAll: (departure === null || departure === void 0 ? void 0 : departure.length) === (cities === null || cities === void 0 ? void 0 : cities.length)
        },
        {
            queryFieldName: TravellerFields.ArrivalQuery,
            arrayFieldName: TravellerFields.Arrival,
            selectedOptions: arrival,
            label: t('Arrival cities'),
            icon: 'Flight/Land',
            selectedAll: (arrival === null || arrival === void 0 ? void 0 : arrival.length) === (cities === null || cities === void 0 ? void 0 : cities.length)
        }
    ], [departure, arrival, cities, t]);
    const filterOptions = (options, value, selectedOptions) => {
        var _a;
        return (_a = options === null || options === void 0 ? void 0 : options
        /** Поиск по опциям */
        .filter(option => { var _a, _b; return (_b = (_a = option.label) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(value === null || value === void 0 ? void 0 : value.toLowerCase()); })) === null || _a === void 0 ? void 0 : _a.filter(option => !(selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.find(selected => selected.value === option.value)));
    };
    const addOption = (field, value) => {
        form.mutators.directionsMutator(field, value, 'add');
    };
    const deleteOption = (field, value) => {
        form.mutators.directionsMutator(field, value, 'delete');
    };
    return {
        fields,
        options,
        addOption,
        deleteOption,
        filterOptions
    };
};
